import { render, staticRenderFns } from "./PointsPackageForm.vue?vue&type=template&id=0cb4abde&scoped=true&"
import script from "./PointsPackageForm.vue?vue&type=script&lang=js&"
export * from "./PointsPackageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb4abde",
  null
  
)

export default component.exports